<template>
  <!-- Este picker é diferente porque é uma lista multivalorada
       de CostCenters, mas:

       - nunca existe o item "Todos" (pois não é um filtro de busca,
         mas sim de execução de comando de cálculo de medição)
       - existe um campo para filtrar
       - existem chips para mostrar os selecionados E existem
         os checkboxes na lista (servem para a mesma coisa)
    -->
  <div>
    <ODialog ref="dialog" :maxWidth="1000">
      <v-card>
        <ODialogBar title="Selecione autorizados" @close="dismiss" />

        <PanelMultiple
          class="maxh-5"
          strings="autorizado;o"
          :items="allItems"
          v-model="copiedValue"
        />

        <ODialogButtons
          class="pa-6"
          txtApply="OK"
          @cancel="dismiss"
          @apply="apply"
        />
      </v-card>
    </ODialog>

    <!-- NB: BasePicker só emite input qdo clica no clear -->
    <BasePicker
      label="Autorizados"
      strings="autorizado;o"
      icon="mdi-account"
      :orientation="orientation"
      :whenEmpty="whenEmpty"
      :value="value"
      @input="clear"
      @open="openDialog"
    />
  </div>
</template>

<script>
import BasePicker from 'oderon-vue/cpts/pickers/BasePicker'
import PanelMultiple from 'oderon-vue/cpts/pickers/PanelMultiple.vue'
import { Technician } from '@/models'
import { orderBy } from 'oderon-commons/src/utils'

export default {
  components: {
    BasePicker,
    PanelMultiple
  },
  props: {
    label: { type: String, default: 'Autorizado' },
    orientation: { type: String, default: 'horizontal' },
    value: {},
    whenEmpty: { type: String, default: '(Todos os autorizados)'}
  },
  mounted() {
    this.fetchData()
  },
  data() {
    return {
      allItems: [],
      copiedValue: null
    }
  },
  methods: {
    async fetchData() {
      let rows = await Technician.findAll()
      rows = rows.map((r) => {
        return { id: r.id, name: r.name.replace('Autorizado Oderon - ', '') }
      })
      this.allItems = orderBy(rows, [['name', 'asc']])
    },
    async openDialog() {
      this.copiedValue = JSON.parse(JSON.stringify(this.value))
      let res = await this.$refs.dialog.$open(this.value)
      if (res != null) {
        this.$emit('input', res)
      }
    },
    clear() {
      this.$emit('input', null)
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    apply() {
      this.$refs.dialog.$apply(this.copiedValue)
    }
  }
}
</script>

<style></style>
